import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedGenericS3App from "./EmbeddedGenericS3App";
const GenericS3App = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "AWS S3 Input" }, /* @__PURE__ */ React.createElement("span", null, "This feature retrieves log messages from an S3 Bucket.")), /* @__PURE__ */ React.createElement(EmbeddedGenericS3App, null));
export default GenericS3App;
